import { useEffect } from "react";

const DataBg: React.FC = () => {
  useEffect(() => {
    const elements = document.querySelectorAll("[data-bg]");

    elements.forEach((element) => {
      (
        element as HTMLElement
      ).style.backgroundImage = `url(${element.getAttribute("data-bg")})`;
    });
  }, []);
  return <></>;
};

export default DataBg;
